import { AXIOS_INSTANCE } from '@cocoonspace/sdk-js/axios-client/use-custom-instance'
import type { Invoice } from '@cocoonspace/sdk-js/types/invoice'
import { getUserToken } from '@cocoonspace/shared/libs/firebase'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { FileDown } from 'lucide-react'
import Link from 'next/link'
import { useEffect, useMemo, useState } from 'react'
import { Price } from '~/components/price'
import { TableCell, TableRow } from '~/components/ui/table'
import { InvoiceStatus } from './invoice-status'

export const InvoiceTableRow = ({ invoice }: { invoice: Invoice }) => {
	const [userToken, setUserToken] = useState<string | undefined>('')

	useEffect(() => {
		getUserToken().then(setUserToken)
	}, [])

	const isStatusVisible = useMemo(() => {
		return (
			// @ts-expect-error InvoiceStatus is not typed
			invoice.status !== 'issued' &&
			(invoice.status === 'voided' || invoice.payment_method === 'sepa_credit')
		)
	}, [invoice.status, invoice.payment_method])

	return (
		<TableRow className='divide-x divide-dashed divide-border/75'>
			<TableCell>{dateTimeUtils(invoice.date).customFormat('date')}</TableCell>
			<TableCell>{invoice.ref}</TableCell>
			<TableCell>{invoice.title}</TableCell>

			<TableCell>
				{isStatusVisible && <InvoiceStatus status={invoice.status} />}
			</TableCell>

			<TableCell className='text-right'>
				<Price
					price={invoice.amount}
					taxType='ht'
					className='font-normal'
					taxClassName='text-base'
				/>
			</TableCell>

			<TableCell>
				<div className='flex items-center gap-2'>
					<Link
						href={`${AXIOS_INSTANCE.defaults.baseURL}/invoices/${invoice.ref}?token=${userToken}`}
						target='_blank'
					>
						<FileDown size={20} />
					</Link>
				</div>
			</TableCell>
		</TableRow>
	)
}
